import { useState, useCallback } from 'react';
import { jwtDecode } from "jwt-decode";

const API_BASE = "/api/identity";

export const useAuth = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Вспомогательный метод для запросов
  const apiRequest = useCallback(async (endpoint: string, body: object) => {
    setIsLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(`${API_BASE}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...(token ? { "Authorization": `Bearer ${token}` } : {}) },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Request failed");
      }

      return await response.json();
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const signup = async (data: any) => {
    return await apiRequest("/registration/pcnt/", data);
  };

  const login = async (email: string, password: String) => {
    const data = await apiRequest("/login/", { username: email, password });
    localStorage.setItem("access", data.access);
    localStorage.setItem("refresh", data.refresh);

    const decoded: any = jwtDecode(data.access);
    // console.log("Decoded JWT:", decoded);
    localStorage.setItem("customer_id", decoded.customer_id);
    localStorage.setItem("is_confirmed", decoded.is_confirmed);
    localStorage.setItem("user_id", decoded.user_id);
    localStorage.setItem("app_mode", decoded.app_mode);
    localStorage.setItem("username", decoded.username);
    localStorage.setItem("app_role", decoded.app_role);

    return data;
  };

  const logout = useCallback(() => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("customer_id");
    localStorage.removeItem("is_confirmed");
    localStorage.removeItem("user_id");
    localStorage.removeItem("app_mode");
    localStorage.removeItem("username"),
    localStorage.removeItem("app_role");

    window.location.href = "/login";
  }, []);

  const refresh = async () => {
    const data = await apiRequest("/token/refresh/", {  });
    localStorage.setItem("access", data.access);
  }

  const resetPassword = useCallback(async (email: string) => {
    return apiRequest("/auth/password/reset/", { email });
  }, [apiRequest]);


  const updateCustomer = async (customerId: number) => {
    return await apiRequest("/dj_user/", { customer_id: customerId, });
  };

  return {
    signup,
    login,
    logout,
    refresh,
    resetPassword,
    updateCustomer,
    isLoading,
    error,
    isAuthenticated: !!localStorage.getItem("access"),
    customerId: localStorage.getItem("customer_id") ? parseInt(localStorage.getItem("customer_id")||'0') : null,
    isConfirmed: localStorage.getItem("is_confirmed") === "true",
    mode: localStorage.getItem("app_mode"),
    role: localStorage.getItem("app_role"),
    username: localStorage.getItem("username"),
    userId: localStorage.getItem("user_id") ? parseInt(localStorage.getItem("user_id")||'0') : null,
    tokens: {
      accessToken: localStorage.getItem("access"),
      refreshToken: localStorage.getItem("refresh"),
    },
    hasRole: (role: string) => {
      const userRoles = localStorage.getItem("app_role")?.split(",") || [];
      return userRoles.includes(role);
    },
    roles: localStorage.getItem("app_role")?.split(",") || [],
    email: localStorage.getItem("username") || "",
  };
};